export enum NachrichtenTypeEnum {
  AA = 'AA',
  JC = 'JC',
  FAMKA = 'FAMKA',
  ZAV = 'ZAV'
}
